import React from 'react'

import { Text } from '@wartek-id/text'
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleIcon,
  CollapsibleContent,
} from '@wartek-id/collapsible'

import type { FAQItemProps } from '../../types/faq'

const FAQ2 = (props: FAQItemProps) => {
  return (
    <Collapsible {...props}>
      <CollapsibleTrigger className="!text-left">
        <Text variant="body-sm" className="!font-semibold">
          Apa perbedaan Asesmen Pembelajaran dan AKM Kelas?
        </Text>
        <CollapsibleIcon></CollapsibleIcon>
      </CollapsibleTrigger>
      <CollapsibleContent className="p-4">
        <Text className="mb-6">
          <b>Asesmen Pembelajaran</b> digunakan guru untuk mengetahui{' '}
          <b>kebutuhan belajar dan capaian perkembangan belajar</b> peserta
          didik, yang dapat dilakukan pada awal, tengah, maupun akhir proses
          pembelajaran di kelas.
        </Text>

        <Text className="mb-6">
          <b>AKM Kelas</b> digunakan sekolah untuk mengetahui{' '}
          <b>kemampuan literasi dan numerasi setiap individu</b> perserta didik.
          Hasilnya membantu sekolah dalam menyusun strategi pembelajaran dan
          pemilihan bahan ajar sesuai kompetensi setiap individu peserta didik.
        </Text>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default FAQ2
